'use client';

import React, { createContext, useContext } from 'react';
import { useRouter } from 'next/router';
import { ISSUER_NAME, PARENT_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import useTopCompany from './useTopCompanies';
import { ITopCompanyServerData } from '@/creditflowresearch/application/TopCompanies/interfaces';

type TopIssuersContextType = ReturnType<typeof useTopCompany>;

export const TopIssuersContext = createContext<TopIssuersContextType>(null);

export const useTopIssuersContext = () => {
  const context = useContext(TopIssuersContext);
  if (!context) {
    throw new Error('useTopIssuersContext must be used within the TopIssuersContext');
  }
  return context;
};

interface IProps {
  topParents?: ITopCompanyServerData,
  children: React.ReactNode,
}

const TopIssuersContextProvider = ({ children, topParents }: IProps) => {
  const { query: { companyViewId } } = useRouter();
  return (
    <TopIssuersContext.Provider value={ useTopCompany({
        serverData: topParents,
        companyRole: companyViewId ? ISSUER_NAME : PARENT_NAME,
      }) }
    >
      { children }
    </TopIssuersContext.Provider>
  );
};

export default TopIssuersContextProvider;
